import { $$ } from '../lib/domUtils';

const carousels = $$('.js-carousel');
const delay = 4000;

carousels.forEach(wrapper => {
  const slides = $$(wrapper.children);
  let currentIndex = 0;

  if (slides.length > 1) {
    setInterval(() => {
      currentIndex += 1;
      if (currentIndex >= slides.length) {
        currentIndex = 0;
      }

      slides.forEach(slide => {
        slide.setAttribute('hidden', '');
      });

      slides[currentIndex].removeAttribute('hidden');
    }, delay);
  }
});
